import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper"; // Adjust the path as necessary

export const DecorationCategories = () => {
  const [categories, setCategories] = useState([]);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `Decoration/GetDecorationCategoryDetailsForFrontend`
      );

      if (response && response.length > 0) {
        const mappedCategories = response.map((category) => ({
          ...category,
          image: category.imagePath ? `${ImageURL}${category.imagePath}` : null,
        }));
        setCategories(mappedCategories);
      } else {
        setCategories([]);
      }
    } catch (error) {
      setCategories([]);
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!categories || categories.length === 0) {
    return null; // Or render a loading message
  }

  return (
    <div>
      <section className="rooms1 section-padding pb-60" data-scroll-index={1}>
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Discover</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">
                Categories Of Design/Decor Items
              </div>
            </div>
          </div>
          <div className="row">
            {categories.map((category) => (
              <div className="col-md-6 mb-60" key={category.itemID}>
                <div className="rooms1-single">
                  <div className="rooms1-img">
                    <img
                      className="shop-image"
                      src={category.image}
                      alt={category.itemName}
                    />
                  </div>
                  <div className="rooms1-content active">
                    <div className="row">
                      <div className="col-6 text-start rooms1-title-Dum">
                        <a>{category.itemName}</a>
                      </div>
                      <div className="col-6 text-end">
                        <a className="butn-dark2">
                          <span>
                            <a href={`/cart/${category.itemID}`}>Explore</a>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-12 text-center">
            <a href="/decorationCategoryDetails" className="butn-dark2">
              <span>View More</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
